/* @ngInject */
function RemoveAttachmentController ($scope) {
  const api = {
  }

  this.getApi = () => api

  activate()

  function activate () {
  }

  $scope.unbindCampaign = (assetId) => {
    $scope.close(assetId)
  }

  $scope.closeDialog = function () {
    $scope.close()
  }
}

export { RemoveAttachmentController }
